<template>
  <OriginalRouterLink :to="localizedTo">
    <slot />
  </OriginalRouterLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useUserStore } from '@/stores/UserStore'
import { RouterLink as OriginalRouterLink } from 'vue-router'

const userStore = useUserStore()

const props = defineProps({
  to: {
    type: [String, Object],
    required: true
  }
})

const locale = computed(() => userStore.language)

const localizedTo = computed(() => {
  if (typeof props.to === 'string') {
    return `/${locale.value}${props.to}`
  }

  return {
    ...props.to,
    path: `/${locale.value}${props.to.path || ''}`,
    params: {
      ...props.to.params,
      locale: locale.value
    }
  }
})
</script>
